import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/psf/share/pageContext';

export function PsfShareErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for PsfShare page (error: ${error})`);
}
